import { useTranslation } from 'react-i18next';
import type { KeyResult, KeyResultOccurrence } from '@momentum/types';
import { Badge } from '@/shared/components/ui/Badge';
import { formatDate } from '@/shared/utils/date-utils';
import i18n from '@/i18n';
import { OccurrenceHistoryDrawer } from './OccurrenceHistoryDrawer';

interface KeyResultHistoryDrawerProps {
  keyResult: KeyResult;
  isOpen: boolean;
  onClose: () => void;
}

export const KeyResultHistoryDrawer: React.FC<KeyResultHistoryDrawerProps> = ({
  keyResult,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation('goals');

  return (
    <OccurrenceHistoryDrawer
      title={keyResult.title}
      isOpen={isOpen}
      onClose={onClose}
      current={keyResult.recurrence?.current}
      history={keyResult.recurrence?.history}
      renderCurrentOccurrence={(current) => (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">
              {t('started')}:
            </span>
            <span className="text-sm font-medium">
              {formatDate(current.startDate, 'MMM d, yyyy', i18n.language)}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">
              {t('progress')}:
            </span>
            <span className="text-sm font-medium">
              {keyResult.currentProgress} / {keyResult.quantity}{' '}
              {keyResult.unit}
            </span>
          </div>
        </div>
      )}
      renderPastOccurrence={(occurrence: KeyResultOccurrence) => (
        <>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">
              {t('progress')}:
            </span>
            <span className="text-sm font-medium">
              {occurrence.currentProgress} / {occurrence.quantity}{' '}
              {keyResult.unit}
            </span>
          </div>
          {occurrence.isCompleted && (
            <Badge variant="default" className="mt-2">
              {t('completed')}
            </Badge>
          )}
        </>
      )}
    />
  );
};
